import { Component } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { MdClose } from "react-icons/md";
import RoundButton from "./RoundButton.jsx";

export default class ErrorDialog extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Dialog open={true} sx={{ zIndex: 99999 }}>
                <DialogTitle color="primary" fontSize={12}><b>Oops!</b></DialogTitle>
                <IconButton onClick={e => this.props.onClose()} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent>
                    <Stack  mt={-2}>
                        <Typography variant="caption" mb={2}>Não foi possível continuar com a sua solicitação:</Typography>
                        <Typography border={1} borderRadius={1} p={1} color="red" variant="caption" mb={1}>{this.props.msg}</Typography>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <RoundButton onClick={e => this.props.onClose()}>Ok</RoundButton>
                </DialogActions>
            </Dialog>
        );
    }
}
